// src/app/redux/actions/paramAvantagesActions.js.js

// =========================
// FETCH ALL
// =========================
export const FETCH_PARAM_AVANTAGES_REQUEST = "FETCH_PARAM_AVANTAGES_REQUEST";
export const FETCH_PARAM_AVANTAGES_SUCCESS = "FETCH_PARAM_AVANTAGES_SUCCESS";
export const FETCH_PARAM_AVANTAGES_FAIL = "FETCH_PARAM_AVANTAGES_FAIL";

// =========================
// CATEGORIES
// =========================
export const CREATE_AV_CAT_REQUEST = "CREATE_AV_CAT_REQUEST";
export const CREATE_AV_CAT_SUCCESS = "CREATE_AV_CAT_SUCCESS";
export const CREATE_AV_CAT_FAIL = "CREATE_AV_CAT_FAIL";

export const UPDATE_AV_CAT_REQUEST = "UPDATE_AV_CAT_REQUEST";
export const UPDATE_AV_CAT_SUCCESS = "UPDATE_AV_CAT_SUCCESS";
export const UPDATE_AV_CAT_FAIL = "UPDATE_AV_CAT_FAIL";

export const DELETE_AV_CAT_REQUEST = "DELETE_AV_CAT_REQUEST";
export const DELETE_AV_CAT_SUCCESS = "DELETE_AV_CAT_SUCCESS";
export const DELETE_AV_CAT_FAIL = "DELETE_AV_CAT_FAIL";

// =========================
// REGLES
// =========================
export const CREATE_AV_REGLE_REQUEST = "CREATE_AV_REGLE_REQUEST";
export const CREATE_AV_REGLE_SUCCESS = "CREATE_AV_REGLE_SUCCESS";
export const CREATE_AV_REGLE_FAIL = "CREATE_AV_REGLE_FAIL";

export const UPDATE_AV_REGLE_REQUEST = "UPDATE_AV_REGLE_REQUEST";
export const UPDATE_AV_REGLE_SUCCESS = "UPDATE_AV_REGLE_SUCCESS";
export const UPDATE_AV_REGLE_FAIL = "UPDATE_AV_REGLE_FAIL";

export const DELETE_AV_REGLE_REQUEST = "DELETE_AV_REGLE_REQUEST";
export const DELETE_AV_REGLE_SUCCESS = "DELETE_AV_REGLE_SUCCESS";
export const DELETE_AV_REGLE_FAIL = "DELETE_AV_REGLE_FAIL";

// =========================
// AVANTAGES
// =========================
export const CREATE_AVANTAGE_REQUEST = "CREATE_AVANTAGE_REQUEST";
export const CREATE_AVANTAGE_SUCCESS = "CREATE_AVANTAGE_SUCCESS";
export const CREATE_AVANTAGE_FAIL = "CREATE_AVANTAGE_FAIL";

export const UPDATE_AVANTAGE_REQUEST = "UPDATE_AVANTAGE_REQUEST";
export const UPDATE_AVANTAGE_SUCCESS = "UPDATE_AVANTAGE_SUCCESS";
export const UPDATE_AVANTAGE_FAIL = "UPDATE_AVANTAGE_FAIL";

export const DELETE_AVANTAGE_REQUEST = "DELETE_AVANTAGE_REQUEST";
export const DELETE_AVANTAGE_SUCCESS = "DELETE_AVANTAGE_SUCCESS";
export const DELETE_AVANTAGE_FAIL = "DELETE_AVANTAGE_FAIL";

// =========================
// LOADING / ERROR
// =========================
export const SET_PARAM_AVANTAGES_LOADING = "SET_PARAM_AVANTAGES_LOADING";
export const CLEAR_PARAM_AVANTAGES_ERROR = "CLEAR_PARAM_AVANTAGES_ERROR";

// =========================
// ACTION CREATORS
// =========================
export const setParamAvantagesLoading = (loading) => ({
    type: SET_PARAM_AVANTAGES_LOADING,
    payload: loading,
});

export const clearParamAvantagesError = () => ({
    type: CLEAR_PARAM_AVANTAGES_ERROR,
});

// FETCH ALL
export const fetchParamAvantagesRequest = () => ({ type: FETCH_PARAM_AVANTAGES_REQUEST });
export const fetchParamAvantagesSuccess = (data) => ({ type: FETCH_PARAM_AVANTAGES_SUCCESS, payload: data });
export const fetchParamAvantagesFail = (error) => ({ type: FETCH_PARAM_AVANTAGES_FAIL, payload: error });

// CATEGORIES
export const createAvCatRequest = (payload) => ({ type: CREATE_AV_CAT_REQUEST, payload });
export const createAvCatSuccess = (created) => ({ type: CREATE_AV_CAT_SUCCESS, payload: created });
export const createAvCatFail = (error) => ({ type: CREATE_AV_CAT_FAIL, payload: error });

export const updateAvCatRequest = (id, payload) => ({ type: UPDATE_AV_CAT_REQUEST, payload: { id, payload } });
export const updateAvCatSuccess = (updated) => ({ type: UPDATE_AV_CAT_SUCCESS, payload: updated });
export const updateAvCatFail = (error) => ({ type: UPDATE_AV_CAT_FAIL, payload: error });

export const deleteAvCatRequest = (id) => ({ type: DELETE_AV_CAT_REQUEST, payload: id });
export const deleteAvCatSuccess = (id) => ({ type: DELETE_AV_CAT_SUCCESS, payload: id });
export const deleteAvCatFail = (error) => ({ type: DELETE_AV_CAT_FAIL, payload: error });

// REGLES
export const createAvRegleRequest = (payload) => ({ type: CREATE_AV_REGLE_REQUEST, payload });
export const createAvRegleSuccess = (created) => ({ type: CREATE_AV_REGLE_SUCCESS, payload: created });
export const createAvRegleFail = (error) => ({ type: CREATE_AV_REGLE_FAIL, payload: error });

export const updateAvRegleRequest = (id, payload) => ({ type: UPDATE_AV_REGLE_REQUEST, payload: { id, payload } });
export const updateAvRegleSuccess = (updated) => ({ type: UPDATE_AV_REGLE_SUCCESS, payload: updated });
export const updateAvRegleFail = (error) => ({ type: UPDATE_AV_REGLE_FAIL, payload: error });

export const deleteAvRegleRequest = (id) => ({ type: DELETE_AV_REGLE_REQUEST, payload: id });
export const deleteAvRegleSuccess = (id) => ({ type: DELETE_AV_REGLE_SUCCESS, payload: id });
export const deleteAvRegleFail = (error) => ({ type: DELETE_AV_REGLE_FAIL, payload: error });

// AVANTAGES
export const createAvantageRequest = (payload) => ({ type: CREATE_AVANTAGE_REQUEST, payload });
export const createAvantageSuccess = (created) => ({ type: CREATE_AVANTAGE_SUCCESS, payload: created });
export const createAvantageFail = (error) => ({ type: CREATE_AVANTAGE_FAIL, payload: error });

export const updateAvantageRequest = (id, payload) => ({ type: UPDATE_AVANTAGE_REQUEST, payload: { id, payload } });
export const updateAvantageSuccess = (updated) => ({ type: UPDATE_AVANTAGE_SUCCESS, payload: updated });
export const updateAvantageFail = (error) => ({ type: UPDATE_AVANTAGE_FAIL, payload: error });

export const deleteAvantageRequest = (id) => ({ type: DELETE_AVANTAGE_REQUEST, payload: id });
export const deleteAvantageSuccess = (id) => ({ type: DELETE_AVANTAGE_SUCCESS, payload: id });
export const deleteAvantageFail = (error) => ({ type: DELETE_AVANTAGE_FAIL, payload: error });
